// import components
import Slider from '../components/dynamic/Slider'
import District from '../components/dynamic/District'
import Relux from '../components/dynamic/Relux'
import LastSeenAds from '../components/dynamic/LastSeenAds'
import City from '../components/dynamic/City'
import Services from '../components/dynamic/Services'
import Video from '../components/dynamic/Video'
import Map from '../components/dynamic/Map'
import Exclusive from '../components/dynamic/Exclusive'


function Home({locale}) {
    
    return (
        <div className='main'>
            <Slider locale={locale} />
            <Relux locale={locale} />
            <LastSeenAds locale={locale} />
            <District locale={locale} />
            <City locale={locale} />
            <Services locale={locale} />
            <Map locale={locale} />
            <Exclusive locale={locale} />
            <Video locale={locale} />
        </div>
    )
    
}

export default Home;